(() => {
  if (customElements.get('localization-form')) {
    return;
  }

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const select = this.querySelector('select');
      if (!select) {
        return;
      }

      select.addEventListener('change', (event) => {
        event.stopImmediatePropagation();
        event.stopPropagation();
        this.closest('form')?.submit();
      });
    }
  }

  customElements.define('localization-form', LocalizationForm);
})();
